import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { lockBackwardNavigation, unlockBackwardNavigation } from 'actionCreators/navigation';

/**
 * Prevents backward navigation on mount, and releases the lock on unmount.
 */
function useBackNavigationLock() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(lockBackwardNavigation());

    return function cleanupBackNavigationLock() {
      dispatch(unlockBackwardNavigation());
    };
  }, [dispatch]);
}

export { useBackNavigationLock };
